module.exports = __webpack_public_path__ + "img/app_ios_d.0e70d513.png";